<div class="flash-content" [formGroup]="privacyConfigForm">
    <div class="flash-content-body">

    <h6><b>Data Privacy Notice</b></h6> 
      <br><h6><b>Introduction</b></h6>

            Al Tasnim Enterprises LLC (“<b>ATNM</b>”, “<b>We</b>”, “<b>Us</b>” or “<b>Our</b>”) is committed to protecting your personal data. This Privacy Notice (“<b>Notice</b>”) is addressed to our the users of ATNM Digital Systems (‘iLMS’, ‘IVMS’, ‘EMS’, ‘FMS’,‘SAP’) based in the Sultanate of Oman (“<b>Oman</b>”).<br>
            This Privacy Notice will help you to understand what personal data we collect about you, why we collect and use (process) it and what we do with it.<br> 
            We determine how and why we use and collect your personal data. Therefore, we act as the controller of your personal data under the Personal Data Protection Law in the Sultanate of Oman (the “<b>Oman Personal Data Protection Law</b>" or the “<b>Law</b>”).<br>  
            In case of any major changes in how we collect and process your personal data, we will notify you via your relevant Division Manager or Head of Department.

    <h6><br><b>What is personal data and processing?</b></h6>
         <b>What is personal data?</b>

        <br> Personal data means any data by which you may be identified as an individual. The personal data that we collect from you may be different, depending on the circumstances. For example, it may include the following:
        <ul>
          <li>
            First name, last name, address, contact details (e.g. phone number, email);
          </li>
          <li>
            Passport number, Civil number (legal ID), Resident Card (Iqama) (for non-Omani), Driving License number;
          </li>
          <li>
            Company name, your company email address;
          </li>
          <li>
            Vehicle number, pickup and drop off location(s);
          </li>
          <li>
            Defensive driving details, fitness and health information;
          </li>
          <li>
            Digital Identification Keys like iLMS QR Codes, EMS Card, FMS Card, iLMS/IVMS Keys, Digital Performance Score
          </li>
            <li>
             Footages of In-vehicle Monitoring System or Driver Fatigue Monitoring System.
          </li>
        </ul> 

        <div class="">
        <b>What is processing?</b>
        <br>Processing means doing anything with personal data, including its collection, recording, analysis, organization, storage, modification, alteration, retrieval, revision, coordination, combination, blocking, erasure, cancellation or disclosure, by sending, distributing, transferring, relocation, etc. 
        
       <h6><br><b>What legal bases do we use for processing your personal data? </b></h6>
                  We will use a legal basis to process your personal data. This means we will have a legal justification to use your personal data, as required by the Law.  
              <br>We may rely on the following legal basis to process your personal data under the Law:  
        <ul>
          <li>
            Your explicit consent (we will let you know on a case-by-case basis should we require your consent);

    <br><br>and the following are exceptions where consent is not required: 
          </li>

    <br> <li>
            Performance of a legal obligation imposed on ATNM  under any law, judgment or court decision;
          </li>
          <li>
            Performance of a contract to which you are a party;
          </li>
          <li>
            Protection of your vital interest;
          </li>
          <li>
            Protection of national security or public interest;
          </li>
          <li>
            Protection of the economic and financial interests of the country;
          </li>
          <li>
            Detection or prevention of any criminal offense based on an official written request from the investigation authorities;
          </li>
          <li>
            Execution by units of administrative apparatus of public legal entities of their powers, as they are prescribed to them by the law;
          </li>
          <li>
            Processing is for the purposes of historical, statistical, scientific, literature or economic research (under certain conditions);
          </li>
          <li>
            Data is publicly available and such availability does not violate provisions of the Law.
          </li>
        </ul>
      </div>

       <h6><br><b>When, how and why do we process your personal data? </b></h6>
      <div class="padding-top-10">
        We may process your personal data in many ways depending on the purpose of processing, as specified below. The ways of how we may process your personal data may include viewing, collecting, using, storing, sharing, modifying, printing, copying, archiving, erasing, etc. 
        <br>We process your personal data for the following purposes: 
        <ul>
          <li>
              Monitoring digital data generated from logistics requests, passenger travel details, fuel collection details, operator actions on the equipment, driver actions on the vehicle.
          </li>
            <li>
           Monitoring and tracking continuously our assets (buses and cars) during your travel journey along with planned journey;
          </li>
          <li>
           Generation of performance scores, performance scores which can further processed for rewards/incentives and consequences/penalties.
         </li>
           <li>
           Providing driver training and certification to you;
          </li>
          <li>
           Handling fitness to work data process;
          </li>
          <li>
            Monitoring our road safety dashboard (it allows us to track your performance or violations of rules, to track behaviour during driving e.g., over speeding, (not)wearing a seat belt, phone usage);
          </li>
          <li>
            Reporting monthly on each driver performance and sharing the report with the relevant 3rd party management.
          </li>
          <li>
            Using our driver fatigue monitoring system (it allows us to analyse your face and mimics based on face recognition to track your tiredness level for your safety);
          </li>
          <li>
            Implementing road safety campaigns;
          </li>
          <li>
            Conducting spot checks (physical checks on the road from our Road Safety team);
          </li>
          <li>
            Handling incident reporting and investigation.
          </li>
        </ul>
       <br> Please note that if we do not complete the collection of personal data for the above purposes, we will not be able to fully guarantee your rights and provide you with a safe working environment. 

       <br> As for the method of collecting your personal data - we may collect it directly from you and in some circumstances, from third parties or systems such as IVMS, EMS, FMS, iLMS etc.   

        <br> In the course of your contracting with us, if there is a change in your personal data, for example, your address, phone numbers, etc., please let us know as soon as possible by contacting your contract holder.
      </div>

      <h6><br><b>Your rights in relation to processing of your personal data</b></h6>
      <div class="padding-top-10">
        In accordance with the Law, you may exercise the following rights:  
        <ul>
          <li>
            Right to withdraw Consent to personal data processing;
          </li>
          <li>
            Right to modify, update, or block the processing of personal data;
          </li>
          <li>
            Right to obtain a copy of personal data;
          </li>
          <li>
            Right to transfer personal data to another Controller;
          </li>
          <li>
            Right to request erasure of personal data;
          </li>
          <li>
            Right to complain to Ministry of Transport, Communications and Information Technology (“MTCIT”).
          </li>
        </ul>

        <br>if you would like to know more about your rights or if you would like to exercise any of them.
        <br>Email: complianceofficer.pdpl@altasnim.com
        <br>Short Code: 3000
        <br>Phone No.: +968 936 50 936

        
      </div>

      <h6><br><b>Storing personal data </b></h6>
      <div class="padding-top-10">
        We will arrange safe storage of your personal data in all the information systems that are used to process personal data. 

        <br> We will determine the period of storage of your personal data in accordance with ATNM Digital Records Management Manual or Client Requirements where applicable (in case of Client PDO, it shall be accordance with PDO Records Management Manual – Classification Scheme and Retention Schedule Specification SP-2492) as well as the other applicable Laws. In particular, when determining the period of storage of your personal data we will take into account:
        
        <ul>
          <li>
            Requirements to the storage period, as such requirements are specific in applicable laws and regulations;
          </li>
          <li>
            Specific purposes for which we require your personal data.
          </li>
        </ul>
      </div> 

      <h6><br><b> Disclosure of your personal data </b></h6>
      <div class="padding-top-10">
        We may, as could be required for the purposes listed above, disclose your personal data - as required and limited to the activities requires execution - to the following organizations: 
        <ol>
          <li>
            Contracting driving company (data sharing with journey managers within the Company or its Clients);
          </li>
          <li>
            Current or potential contractors, suppliers, vendors, business partners or other third parties who provide us with data processing, professional or management services, such as suppliers providing in vehicle monitoring systems, vendor providing driver fatigue monitoring system, training providers;
          </li>
           <li>
            Any member of our ATNM group (e.g. managing operational activities in the group);
          </li>
          <li>
           Any applicable regulatory authorities (governmental and other public bodies, for example, Ministry Of Labour, Internal Security Agency, Royal Oman Police, etc.) or other third parties as could be required by law or in accordance with other regulatory obligations or policies applicable to us or to you.
          </li>
        </ol>
       <br> Please note that some of your personal data may be published on our intranets, websites and publications for the purpose of sharing knowledge, information in relation to our business. Such personal data may include, for example: your name, contact details, job title, your photograph, your video, etc. 

       <br> When providing your personal data to the entities with whom we have contractual relations, we request a confirmation of the security measures these legal entities take to protect the personal data we provide. We do not share the personal data with public authorities or other third parties without a proper lawful request of the authorities. 

       <br> We make best efforts to ensure we have relevant contractual agreements in place with the parties with whom we share your personal data with and that they comply with data protection requirements of Oman and ATNM.
      </div> 

      <h6><br><b>Cross-border personal data transfers</b></h6>
      <div class="padding-top-10">
       We don’t transfer your personal data for processing outside of Oman. However, if we might transfer your personal data for processing outside of Oman in the future, we will comply with the requirements of the Law regarding the cross-border personal data transfers, as well as with the requirements of other laws and regulations, where applicable. 
      </div>
      <h6><br><b>Protecting personal data</b></h6>
      <div class="padding-top-10">
      We protect your personal data by using a range of methods, procedures and techniques. For example: 
       <ol>
          <li>
            We have assigned the responsibility for personal data processing to specific employees;
          </li>
          <li>
            We have in place policies and procedures in the area of protection of personal data to ensure that our personal data processing activities comply with the Law;
          </li>
           <li>
            We have implemented the necessary organizational and technical measures to protect personal data (access control, encryption);
          </li>
          <li>
            We have organized a process of receiving and controlling the processing of data subjects’ requests;
          </li>
          <li>
            We keep up to date the Records of Processing Activities (RoPA);
          </li>
          <li>
            We carry out a Data Protection Impact Assessment (DPIA) for personal data processing activities that results a high risk;
          </li>
          <li>
            We ensure security of third parties (controllers, processors);
          </li>
          <li>
            We carry out planned and unscheduled audits of personal data processing activities.
          </li>
        </ol>
       </div>

      <h6><br><b>Disposal of personal data </b></h6>
      <div class="padding-top-10">
       If we no longer need your personal data and if we do not have any legal basis to hold it further, we will arrange its erasure (destruction), anonymisation or return to you (unless we must return it to any other entity based on our legal obligations). 
       <br> We will ensure that:  
        <ol>
          <li>
            In case of anonymisation: you will not be further re-identified after anonymization;
          </li>
          <li>
           In case of erasure (destruction): the personal data will not be reconstructed after it was erased.
          </li>
       </ol>
       </div>
       <h6><br><b>Withdrawal of consent </b></h6>
      <div class="padding-top-10">
      In some cases, we may request your consent to processing of your personal data. When we request your consent, we will also explain to you how you can withdraw your consent. If you have any questions regarding the consent that you may provide to us (or already provided), as well as how you can withdraw it - you may contact us with the use of the contact details, specific in section “Contact details” of this Notice. <br>
      
          In specific cases where a driver withdraws consent to the processing of their personal data, Al Tasnim Enterprises LLC will cease all collection and use of that driver’s personal data and journeys thereafter.  As a result, No trip-related data will be processed, and the driver's performance score for that journey will be recorded as NIL, with the reason marked as “PDPL Authorization Withdrawn.”.  Any Performance Incentive (PI) or rating dependent on trip data will have no base input and will therefore be automatically categorized as P0 (no data available).  
       </div> 
       <h6><br><b>Contact details</b></h6>
      <div class="padding-top-10"> 
      If you have any questions or comments regarding our use of your personal data, please contact us by using the following contact details:  
      <br><b>Address:</b> Building No. 484, Way No. 5007, Al Hirmal Street, Ghala, Muscat 
      <br><b>Email:</b> complianceofficer.pdpl@altasnim.com
      <br> Consent for the use of personal data: <br>
      I understand that I may withdraw the consent to the use of my personal data, provided that the employment contract with my company is no longer valid. I understand that any such withdrawal of consent will not affect the validity of any prior use of my personal data by ATNM.<br>
      I consent and acknowledge, understand and accept that such withdrawal of consent will result in the absence of performance data for the relevant trip and that this may affect performance monitoring incentive or reporting systems dependent on trip-level data.I confirm that I have full legal capacity for the purpose of giving this consent. (Applicable only to drivers) <br>
    <br> <div class="checkboxes">
    <input type="checkbox" formControlName="strPdoPrivacy" name="personal" id="personal">
     <label> I acknowledge that I have read and understood and hereby agree to the terms of ATNM’s privacy notice above, which explains how ATNM may use my personal data and what rights I have.</label><br>
    <br> <input type="checkbox" formControlName="strDataPrivacy" name="confirm" id="confirm">
     <label> I consent to the use of my personal data by ATNM, according to Privacy Notice above.</label>
    </div> 
     </div> 
       <div class="flash-footer">
      <button class="btn btn-primary" [disabled]="!privacyConfigForm.valid"  (click)="onSubmit()">Submit</button>
    </div>
  </div>
  </div>